export default {
  features: {
    updateClientQuestionnaire: {
      title: "Shaxsiy ma'lumotlar",
      save: 'Saqlash',
    },
  },
};
